import { combineReducers } from 'redux';
import loginStatus from './loginStatus';
import donation from './donation';
import route from './route';
import tlid from './id';
import error from './error';
import verifyStatus from './verifyStatus';
// import asyncs from './asyncs';


// Updates the remote call data for different actions.
/* const asyncsReducers = combineReducers({
  verifyStatus: asyncs({
    mapActionToKey: action => action.type,
    types: [
      ActionTypes.LOGIN_REQUEST,
      ActionTypes.LOGIN_SUCCESS,
      ActionTypes.LOGIN_FAILURE
    ]
  })
});*/

const tinabalikeApp = combineReducers({
  donation,
  route,
  loginStatus,
  tlid,
  verifyStatus,
  error
});

export default tinabalikeApp;



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/